import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { getDiffColor, getDiffDirectionSymbol } from '../helpers'
import Icon from '../../Icons'
import UpsellingBlocker from '../UpsellingBlocker'
import Can from '../../Can'

const FeedAndGroups = ({ marketingData }) => {
  const { t } = useTranslation(['building-analytics'])
  const posts = marketingData && marketingData.groups && marketingData.groups.posts
  const postsPending = marketingData && marketingData.groups && marketingData.groups.postsPending

  return (
    <div className="marketing-statistic-row-block">
      <h3 className="title">{t('building-analytics:feedAndGroups.title')}</h3>
      <Can
        on={'Navbar'}
        to={'groups'}
        feedFlag={'groupsAvailable'}
        upsellingLink={
          <UpsellingBlocker
            type="groups"
            text={t('building-analytics:feedAndGroups.upsellingText')}
            wrapperClassName="marketing-statistic-row-block__upselling-blocker"
          />
        }
      >
        <React.Fragment>
          <span className="subtitle-text">{t('building-analytics:feedAndGroups.postsTotal')}</span>
          <div className="marketing-statistic-row-block__bottom-wrapper">
            <h3 className="marketing-statistic-row-block__bottom-wrapper__number">
              {(posts && posts.value) || '0'}
            </h3>
            {posts && posts.percentageDiff !== '-' && (
              <div
                className={`marketing-statistic-row-block__bottom-wrapper__percent-wrapper  ${getDiffColor(
                  posts,
                )}`}
              >
                <span className="percent-text">
                  {posts && posts.percentageDiff && posts.percentageDiff !== 'NaN'
                    ? `${getDiffDirectionSymbol(posts.percentageDiff)} ${posts.percentageDiff}%`
                    : '00.00%'}
                </span>
              </div>
            )}
          </div>
          {postsPending ? (
            <div className="marketing-statistic-row-block__warning-wrapper">
              <Icon icon="exclamationPointTriangle" fill="#EE8E00" />
              <div>{postsPending}</div>
              <div>{t('building-analytics:common.pending')}</div>
            </div>
          ) : null}
          <Link className="redirect-button" to="/dashboard/building-dashboard/groups/posts">
            <span>{t('building-analytics:feedAndGroups.goToFeedGroups')}</span>
            <Icon
              styles={{ width: '20px', paddingLeft: '5px' }}
              viewBox="0 0 20 20"
              icon={'arrowRight'}
              svgProps={{ stroke: '#646464', strokeLinecap: 'round', strokeLinejoin: 'round' }}
              fill="none"
            />
          </Link>
        </React.Fragment>
      </Can>
    </div>
  )
}

FeedAndGroups.propTypes = {
  marketingData: PropTypes.object,
}
export default FeedAndGroups
